import React, {useEffect, useRef, useState} from 'react'

type Props = {
  placeholder?: string
  onScan: (code: string) => void
  autoFocus?: boolean
  disabled?: boolean
}

// Champ de scan : une douchette USB se comporte comme un clavier et termine la saisie par Entrée
const SavScanInput = ({
  placeholder = 'Scanner ou saisir un code',
  onScan,
  autoFocus = false,
  disabled = false,
}: Props) => {
  const [code, setCode] = useState('')
  const champ = useRef<HTMLInputElement>(null)

  useEffect(() => {
    if (autoFocus) champ.current?.focus()
  }, [autoFocus])

  const valider = () => {
    const valeur = code.trim()
    if (!valeur) return
    onScan(valeur)
    setCode('')
  }

  return (
    <div className='input-group'>
      <span className='input-group-text'>
        <i className='bi bi-upc-scan fs-4'></i>
      </span>
      <input
        ref={champ}
        className='form-control form-control-solid'
        placeholder={placeholder}
        value={code}
        disabled={disabled}
        onChange={(e) => setCode(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === 'Enter') {
            e.preventDefault()
            valider()
          }
        }}
      />
      <button
        type='button'
        className='btn btn-light-primary'
        onClick={valider}
        disabled={disabled || !code.trim()}
      >
        OK
      </button>
    </div>
  )
}

export default SavScanInput
